/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/card';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "ListCardsRequest": {
                "fields": {}
              },
              "ListCardsResponse": {
                "fields": {
                  "cards": {
                    "type": ".squareup.corporate_card.resources.Card",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.ListCardsRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.ListCardsResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ListCardsRequest @ squareup/corporate_card/service/list_cards.proto at 9:1
 */
export const ListCardsRequest = $root.lookupType('squareup.corporate_card.service.ListCardsRequest');
fixType(ListCardsRequest);
Builder.createAndAttachToType(ListCardsRequest);
/**
 * SOURCE ListCardsResponse @ squareup/corporate_card/service/list_cards.proto at 12:1
 */
export const ListCardsResponse = $root.lookupType('squareup.corporate_card.service.ListCardsResponse');
fixType(ListCardsResponse);
Builder.createAndAttachToType(ListCardsResponse);